import { render, staticRenderFns } from "./BannerManage.vue?vue&type=template&id=a187c9d6"
import script from "./BannerManage.vue?vue&type=script&lang=js"
export * from "./BannerManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports